// @flow
import type { Ancillary, AncillaryPerSegment } from "../actions"
import type { AncillaryService } from "./consts"

export const SET_ANCILLARIES = "SET_ANCILLARY_SERVICES"
export const ADD_ANCILLARY = "ADD_ANCILLARY_SERVICE"
export const REMOVE_ANCILLARY = "REMOVE_ANCILLARY_SERVICE"
export const SET_ANCILLARY_STATUS = "SET_ANCILLARY_STATUS"

export type AdditionalServices = {
  paid_checkin?: Ancillary,
  airhelp_plus?: Ancillary,
  fast_track?: Ancillary,
  blueribbon_bags?: AncillaryPerSegment,
}

export type setAncillaryAction = {
  type: "SET_ANCILLARY_SERVICES",
  payload: AdditionalServices,
}

export type addRemoveAncillaryAction = {
  type: "ADD_ANCILLARY_SERVICE" | "REMOVE_ANCILLARY_SERVICE",
  meta: { service: AncillaryService, forPassengers: Array<number> },
}

export type ancillariesLoadingAction = {
  type: "SET_ANCILLARY_STATUS",
  payload: {
    services: AncillaryService[],
    isLoading: boolean,
  },
}

/**
 * Action creator for setting data from 3rd party non-flight ancillaries server to state to state,
 * for all registered ancillary reducers.
 * @param {AdditionalServices} payload - payload from the server
 */
export const setAncillaryServices = (payload: AdditionalServices): setAncillaryAction => ({
  type: SET_ANCILLARIES,
  payload,
})

/**
 * Action creator for registering that particular service was added by user
 * @param {string} service - name of the service that was added
 * @param {Array<number>} forPassengers - optional argument that indicates for which passengers was
 * the service added
 */
export const addAncillaryService = (
  service: AncillaryService,
  forPassengers?: Array<number> = [],
): addRemoveAncillaryAction => ({
  type: ADD_ANCILLARY,
  meta: { service, forPassengers },
})

/**
 * Action creator for registering that particular service was removed by user
 * @param {string} service - name of the service that was removed
 * @param {Array<number>} forPassengers - optional argument that indicates for which passengers was
 * the service removed
 */
export const removeAncillaryService = (
  service: AncillaryService,
  forPassengers?: Array<number> = [],
): addRemoveAncillaryAction => ({
  type: REMOVE_ANCILLARY,
  meta: { service, forPassengers },
})

/**
 * Action creator for registering that particular service or services started loading
 *
 * @param {Array<service>} - list of services for which you want to start loading
 */
export const startAncillariesLoading = (
  services: AncillaryService[],
): ancillariesLoadingAction => ({
  type: SET_ANCILLARY_STATUS,
  payload: {
    services,
    isLoading: true,
  },
})

/**
 * Action creator for registering that particular service or services stopped loading
 *
 * @param {Array<service>} - list of services for which you want to stop loading
 */
export const stopAncillariesLoading = (services: AncillaryService[]): ancillariesLoadingAction => ({
  type: SET_ANCILLARY_STATUS,
  payload: {
    services,
    isLoading: false,
  },
})
